import {
  useToast as UIUseToast,
  Toast,
  VStack,
  ToastTitle,
  ToastDescription,
  useBreakpointValue,
  HStack
} from "@gluestack-ui/themed";

export const useToast = () => {
  const toast = UIUseToast();

  const width = useBreakpointValue({
    base: "calc(100% - $8)",
    md: "calc(100% - $16)",
    lg: "$96"
  });

  const mx = useBreakpointValue({
    base: "$4",
    md: "$8",
    lg: "auto"
  });

  const _show = (
    actionType: "info" | "success" | "error" | "warning",
    title: string,
    description: string,
    icon?: JSX.Element
  ) => {
    toast.show({
      placement: "top",
      // Toast return any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: ({ id }: any) => {
        const toastId = "toast-" + id;
        return (
          <Toast
            nativeID={toastId}
            action={actionType}
            variant="solid"
            top="$12"
            width={width}
            mx={mx}
            maxWidth="$96"
          >
            <VStack space="xs" width="$full">
              <HStack flexWrap="wrap" alignItems="flex-start" width="$full">
                {icon ? (
                  <HStack mr="$2" flexShrink={0}>
                    {icon}
                  </HStack>
                ) : null}
                <ToastTitle flex={1} flexShrink={1} minWidth={0}>
                  {title}
                </ToastTitle>
              </HStack>
              {description ? (
                <ToastDescription
                  flex={1}
                  flexShrink={1}
                  minWidth={0}
                  width="$full"
                >
                  {description}
                </ToastDescription>
              ) : null}
            </VStack>
          </Toast>
        );
      }
    });
  };

  const info = (title: string, description = "", icon?: JSX.Element) => {
    _show("info", title, description, icon);
  };

  const success = (title: string, description = "", icon?: JSX.Element) => {
    _show("success", title, description, icon);
  };

  const error = (title: string, description = "", icon?: JSX.Element) => {
    _show("error", title, description, icon);
  };

  const warning = (title: string, description = "", icon?: JSX.Element) => {
    _show("warning", title, description, icon);
  };

  return { info, success, error, warning };
};

export default useToast;
